import React, { useState, useEffect } from "react";
import { Redirect, Route, Link, useHistory } from "react-router-dom";
import ls from "services/ls";
import AppContext from "contexts/AppContext";
import api from "services/api";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";

//New structured import
import { AngleRight, GiftBox, HeartIcon } from "./Icons";
import Translator, { __ } from "services/Translator";
import UserDropDownMenu from "components/UserDropDownMenu";
import LanguageSwitcherDropdown from "components/LanguageSwitcherDropdown";
import CashierModals from "components/CashierModals";
import CashierRedesign from "components/cashier-redesign/CashierRedesign";
import SearchBox from "elements/SearchBox";

import Logo from "elements/Logo";
import HeaderCrownLine from "components/header/HeaderCrownLine";
import HeaderInfoCarousel from "components/header/HeaderInfoCarousel";

const Header = (props) => {
  const userBalance = useSelector((state) => state.userBalance);
  // const menuOpen = props.menuOpen;
  const history = useHistory();
  const [timeZone, setTimeZone] = useState("America/New_York");

  // expand header before login
  const [redeemTooltipOpen, setRedeemTooltipOpen] = useState(false);
  const handleRedeemTooltipOpen = () => {
    setRedeemTooltipOpen(true);
  };
  const handleRedeemTooltipClose = () => {
    setRedeemTooltipOpen(false);
  };

  // expand header before login
  const [expandHeader, setExpandHeader] = useState(false);
  const toggleExpandHeader = () => {
    if (expandHeader === false) {
      setExpandHeader(true);
    } else {
      setExpandHeader(false);
    }
  };

  // sidebar
  const [showSidebar, setShowSidebar] = useState(false);
  const openSidebar = () => {
    setShowSidebar(true);
  };
  const closeSidebar = () => {
    setShowSidebar(false);
  };

  // notification
  const [notifications, setNotificactions] = useState([]);
  const [notificationModal, setNotificationModal] = useState(false);
  const toggleNotification = () => {
    if (notificationModal === false) {
      setNotificationModal(true);
      getNotifications();
    } else {
      setNotificationModal(false);
    }
  };

  const getNotifications = async () => {
    var response = await api.post("/player/messages-and-notifications", {
      page: 1,
    });
    if (response.status === 200) {
      console.log(response.data.data);
      setNotificactions(response.data.data);
    }
  };

  // clock

  const [currentTime, setCurrentTime] = useState();
  const liveTime = () => {
    setCurrentTime(Date());
  };
  useEffect(() => {
    const interval = setInterval(() => {
      liveTime();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScrollNav(true);
    } else {
      setScrollNav(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", changeNav);
    // ls.get("language");
    // ls.set("timeZone", "America/New_York");
    var getTime = ls.get("timeZone");
    if (getTime) {
      setTimeZone(getTime);
    }
  }, []);

  //open support sidebar
  const [showSupportSidebar, setShowSupportSidebar] = useState(false);
  useEffect(() => {
    if (showSupportSidebar === true) {
      props.showSupportSidebar(showSupportSidebar);
    }
  }, [showSupportSidebar]);

  useEffect(() => {
    if (props.isAuthenticated) {
      isFullVerified();
    }
  }, [props.isAuthenticated]);

  const [verified, setVerified] = useState(false);

  const isFullVerified = async () => {
    // var response = await api.get("/id-uploads");
    // if (
    //   response.data.poif &&
    //   response.data.poib &&
    //   response.data.poif.approved == "approved" &&
    //   response.data.poib.approved == "approved" &&
    //   response.data.poa &&
    //   response.data.poa.approved == "approved" &&
    //   response.data.sof &&
    //   response.data.sof.approved == "approved"
    // ) {
    //   return true;
    // } else {
    //   return false;
    // }

    let response = await api.get("/plaid/id-verification/status");
    let verified =
      response.status === 200 &&
        response.data.status &&
        response.data.status === "success"
        ? true
        : false;
    setVerified(verified);
    return verified;
  };

  return (
    <>
      {/* <SupportSidebar {...props} /> */}

      <section className="headerComponent">
        <div className="headerContent">
          <HeaderCrownLine
            isSidebarCollapsed={props.isSidebarCollapsed}
            isAuthenticated={props.isAuthenticated}
          />
          <HeaderInfoCarousel />
          <div
            className={
              "logoMenubar " +
              (props.showLeftSidebar ? "leftSidebarOpened" : "")
            }
          >
            <div className="logo-sidebar-menu">
              <Logo {...props} />
              {/* {!props.isMobileDevice && (
                <img
                  src={
                    require("assets/play365/images/common/logo.webp")
                  }
                />
              )}
              {props.isMobileDevice && (
                <img
                  src={
                    require("assets/play365/images/common/short-logo.webp")
                      
                  }
                />
              )} */}

              {/* <VipIcon /> */}
              {/* {!props.isMobileDevice && (
                <div
                  className={`container ${!props.isSidebarCollapsed ? 'active' : ''}`}
                  onClick={() => {
                    props.setIsSidebarCollapsed(!props.isSidebarCollapsed);
                  }}
                  aria-label={
                    props.isSidebarCollapsed ? "Open menu" : "Close menu"
                  }
                  role="button"
                  tabIndex={0}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 200 200">
                    <g strokeWidth="12" strokeLinecap="round">
                      <path
                        d="M72 82.286h28.75"
                        fill="#009100"
                        fillRule="evenodd"
                        stroke="#fff"
                      />
                      <path
                        d="M100.75 103.714l72.482-.143c.043 39.398-32.284 71.434-72.16 71.434-39.878 0-72.204-32.036-72.204-71.554"
                        fill="none"
                        stroke="#fff"
                      />
                      <path
                        d="M72 125.143h28.75"
                        fill="#009100"
                        fillRule="evenodd"
                        stroke="#fff"
                      />
                      <path
                        d="M100.75 103.714l-71.908-.143c.026-39.638 32.352-71.674 72.23-71.674 39.876 0 72.203 32.036 72.203 71.554"
                        fill="none"
                        stroke="#fff"
                      />
                      <path
                        d="M100.75 82.286h28.75"
                        fill="#009100"
                        fillRule="evenodd"
                        stroke="#fff"
                      />
                      <path
                        d="M100.75 125.143h28.75"
                        fill="#009100"
                        fillRule="evenodd"
                        stroke="#fff"
                      />
                    </g>
                  </svg>
                </div>
              )} */}
            </div>
          </div>
          <div className="highlightedCta d-none">
            {/* <ul>
              <li>
                <Link hreflang={Translator.getSelectedLanguage().code} to="/promotions">
                  <GiftBox fillColor="#4b486e" />
                  <span>{__("Promotions")}</span>
                </Link>
              </li>
              <li>
                <Link hreflang={Translator.getSelectedLanguage().code} to="/vip">
                  <HeartIcon fillColor="#4b486e" />
                  <span>{__("VIP & Loyalty")}</span>
                </Link>
              </li>
            </ul> */}
            {/* <SearchBox {...props} /> */}
            {/* <div className="shadow-box"></div> */}
          </div>
          

          <div className="userCta">
            <div className="countrySwitcherHeaderSlot">
              <LanguageSwitcherDropdown {...props} />
            </div>
            {!props.isAuthenticated && (
              <div className="nonLoggedIn">
                <ul>
                  <li>
                    <button
                      type="button"
                      onClick={() => {
                        props.setModalSignUpPropsData(true);
                        setTimeout(function () {
                          props.setModalSignUpPropsData(false);
                        }, 500);
                      }}
                      className="gradientLoginBtn "
                    >
                      {__("Sign Up")}
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      onClick={() => {
                        props.setModalLoginPropsData(true);
                        setTimeout(function () {
                          props.setModalLoginPropsData(false);
                        }, 500);
                      }}
                      className="commonBtn pTwoBtn"
                    >
                      {__("Login")}
                    </button>
                  </li>
                </ul>
              </div>
            )}
            {props.isAuthenticated && (
              <div className="loggedIn">
                <div className="walletDepositBlock">
                  {props.cashierRedesignEnabled ? (
                    <>
                      <CashierModals {...props} cashierRedesignEnabled />
                      <CashierRedesign
                        open={
                          props.openWalletModalTab === "deposit" ||
                          props.openWalletModalTab === "withdraw"
                        }
                        onClose={() => props.setOpenWalletModalTab(null)}
                        initialTab={props.openWalletModalTab}
                      />
                    </>
                  ) : (
                    <CashierModals {...props} />
                  )}
                </div>
                <div className="userActions">
                  <div className="userDropdownMenuBlock">
                    <UserDropDownMenu {...props} />
                  </div>
                  {/* {!props.isMobileDevice && (
                    <div className="settingsBlock">
                      <SettingsMenu {...props} />
                    </div>
                  )} */}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Header;
